/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { NavLink } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';

import utils from '../../lib/utils';
import hidenav from '../../assets/images/hide_nav.png';
import brandAnalytics from '../../assets/images/brand-analytics.svg';
import './index.scss';

const isSetupComplete = (softwares) => {
  return !!(softwares && softwares.info && softwares.info.STUDIO_ID);
};

const isSetupScreen = (path) => {
  return [
    '/app/setup',
    '/app/setup/summary',
    '/app/services',
    '/app/staff',
    '/app/schedules',
  ].includes(path);
};

const isPausedBusiness = (softwares) => {
  return !!(
    softwares &&
    softwares.info &&
    softwares.info.subscription_status === 'SUSPENDED'
  );
};

const enableSetUP = (features) => {
  if (features) {
    return (
      features.includes('LOCAL_SCHEDULE_ENABLED') ||
      features.includes('LOCAL_SERVICE_ENABLED') ||
      features.includes('LOCAL_SCHEDULE_ENABLED')
    );
  } else {
    return null;
  }
};

class SideNav extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isDentalSetupCollapsed: false,
      isBusinessPaused: true,
      isBusinessUnsubscribed: true,
      isAdmin: false,
      isCampaignsCollapsed: true,
      isScheduleCollapsed: true,
      isAIsetupCollapsed: true,
      minimize: true,
      manualMinmize: false,
    };

    this.onPreferencesClick = this.onPreferencesClick.bind(this);
    this.onDentalSetupClick = this.onDentalSetupClick.bind(this);
    this.toggleSideMinNav = this.toggleSideMinNav.bind(this);
    this.onCampaignsClick = this.onCampaignsClick.bind(this);
    this.onScheduleClick = this.onScheduleClick.bind(this);
    this.onAIsetupClick = this.onAIsetupClick.bind(this);
    this.clearSession = this.clearSession.bind(this);
  }

  componentDidMount() {
    let isAdmin = false;
    const adminroles = ['ADMIN', 'CS_ADMIN', 'CS_SETUP', 'CS_SALES'];
    if (
      this.props.business &&
      this.props.business.clientUser &&
      adminroles.includes(this.props.business.clientUser.role)
    ) {
      isAdmin = true;
    }
    if (
      this.props.auth &&
      this.props.auth.subscription_status
    ) {
      this.setState({
        isBusinessUnsubscribed: this.props.auth.subscription_status === 'UNSUBSCRIBED',
      });
      
    }
    this.setState({
      isBusinessPaused: utils.getCookie('subscription_status') === 'SUSPENDED',
      isAdmin,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.softwares &&
      nextProps.softwares.info &&
      nextProps.softwares.info.subscription_status
    ) {
      this.setState({
        isBusinessPaused: isPausedBusiness(nextProps.softwares),
      });
    }
    if (
      nextProps.auth &&
      nextProps.auth.subscription_status !== this.props.auth.subscription_status
    ) {
      this.setState({
        isBusinessUnsubscribed: nextProps.auth.subscription_status === 'UNSUBSCRIBED',
      });
    }
    
    const adminroles = ['ADMIN', 'CS_ADMIN', 'CS_SETUP', 'CS_SALES'];
    if (
      nextProps.business &&
      nextProps.business.clientUser &&
      adminroles.includes(nextProps.business.clientUser.role)
    ) {
      this.setState({
        isAdmin: true,
      });
    }
  }

  onPreferencesClick(event) {
    const { softwares } = this.props;

    if (isSetupComplete(softwares)) {
      // All good, do nothing
    } else {
      event.preventDefault();
    }
  }

  onDentalSetupClick() {
    const { location } = this.props;
    const path = location.pathname;
    const setup = isSetupScreen(path);

    if (setup) {
      this.setState((prevState) => {
        return {
          isDentalSetupCollapsed: !prevState.isDentalSetupCollapsed,
        };
      });
    } else {
      this.setState(() => {
        return {
          isDentalSetupCollapsed: false,
        };
      });
    }
  }

  toggleSideMinNav(flag) {
    this.setState({
      minimize: !flag,
      manualMinmize: !flag,
      isCampaignsCollapsed: true,
      isScheduleCollapsed: true,
      isAIsetupCollapsed: true,
    });
    this.props.minimizeSidbar(!flag);
  }

  onCampaignsClick(flag) {
    this.setState({
      isCampaignsCollapsed: !flag,
      minimize: !flag,
    });
  }

  onScheduleClick(flag) {
    this.setState({
      isScheduleCollapsed: !flag,
      minimize: !flag,
    });
  }

  onAIsetupClick(flag) {
    this.setState({
      isAIsetupCollapsed: !flag,
      minimize: !flag,
    });
  }

  clearSession() {
    sessionStorage.removeItem('search');
    sessionStorage.removeItem('searchText');
    this.props.toggleSideNav();
  }

  render() {
    const {
      app,
      softwares,
      dashboard,
      location,
      currentDomain,
      auth,
      business,
      headerPopupVisibility,
    } = this.props;
    const {
      isDentalSetupCollapsed,
      isAdmin,
      isCampaignsCollapsed,
      isScheduleCollapsed,
      isAIsetupCollapsed,
      minimize,
      isBusinessUnsubscribed,
      isBusinessPaused,
    } = this.state;
    const { features } = auth;
    const path = location.pathname;
    const setup =
      currentDomain === 'DENTAL'
        ? isSetupScreen(path)
        : path.startsWith('/app/setup');
    const campaignsactive =
      path === '/app/outreach' || path === '/app/leadengage' ? true : false;
    const isscheduleactive =
      path === '/app/schedulepreview' ||
      path === '/app/servicetypes' ||
      path === '/app/scheduledefinition' ||
      path === '/app/scheduleblocks' ||
      path === '/app/staffmapping'
        ? true
        : false;
    const setupactive =
      path === '/app/preferences' ||
      path === '/app/webbooking' ||
      path === '/app/webchat' ||
      path.startsWith('/app/setup')
        ? true
        : false;

    let errorCount = 0;
    if (dashboard.tasksStatus.bookingSW_connect !== 'completed') {
      errorCount += 1;
    }
    const isPreferencesDisabled = !isSetupComplete(softwares);
    console.log('app.featureAdv', app);
    const csroles = ['CS_ADMIN', 'CS_SETUP', 'CS_SALES'];
    const isCSLogin = csroles.includes(auth.role);
    return (
      <div
        className={classnames(
          'side-nav',
          {
            'side-nav--hide': !app.leftSidenav,
          },
          { 'side-nav--min': minimize },
        )}
      >
        <div
          className={classnames('hide-button', { 'hide-button-min': minimize, 'hide-btn-with-popup': headerPopupVisibility })}
          onClick={() => this.toggleSideMinNav(minimize)}
        >
          <img className="scoll-img" src={hidenav} />
        </div>

        <ul className="side-nav__items" onClick={this.clearSession}>
          {features && features.includes('DASHBOARD_ENABLED') && (
            <li>
              <NavLink
                className="item"
                activeClassName="item--active"
                to="/app/dashboard"
              >
                <i className="material-icons">speed</i>
                <span
                  className={classnames('item-name', { 'hide-name': minimize })}
                >
                  Dashboard
                </span>
              </NavLink>
            </li>
          )}
          {features && features.includes('ANALYTICS_ENABLED') &&
            <li>
              <NavLink
                className="item"
                activeClassName="item--active"
                to="/app/brandanalytics"
              >
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.25 1.5C4.85217 1.5 4.47064 1.65804 4.18934 1.93934C3.90803 2.22064 3.75 2.60218 3.75 3V12.75C3.75 13.1478 3.90803 13.5294 4.18934 13.8107C4.47064 14.092 4.85217 14.25 5.25 14.25H12.75C13.1478 14.25 13.5294 14.092 13.8107 13.8107C14.092 13.5294 14.25 13.1478 14.25 12.75V6.375H10.6875C10.3394 6.375 10.0056 6.23672 9.75942 5.99058C9.51328 5.74444 9.375 5.4106 9.375 5.0625V1.5H5.25ZM6.5625 3.75H7.6875C7.83668 3.75 7.97976 3.80926 8.08525 3.91475C8.19074 4.02024 8.25 4.16332 8.25 4.3125C8.25 4.46168 8.19074 4.60476 8.08525 4.71025C7.97976 4.81574 7.83668 4.875 7.6875 4.875H6.5625C6.41331 4.875 6.27024 4.81574 6.16475 4.71025C6.05926 4.60476 6 4.46168 6 4.3125C6 4.16332 6.05926 4.02024 6.16475 3.91475C6.27024 3.80926 6.41331 3.75 6.5625 3.75ZM6 6.5625C6 6.41331 6.05926 6.27024 6.16475 6.16475C6.27024 6.05926 6.41331 6 6.5625 6H7.6875C7.83668 6 7.97976 6.05926 8.08525 6.16475C8.19074 6.27024 8.25 6.41331 8.25 6.5625C8.25 6.71168 8.19074 6.85476 8.08525 6.96025C7.97976 7.06574 7.83668 7.125 7.6875 7.125H6.5625C6.41331 7.125 6.27024 7.06574 6.16475 6.96025C6.05926 6.85476 6 6.71168 6 6.5625ZM6.5625 8.25H7.6875C7.83668 8.25 7.97976 8.30926 8.08525 8.41475C8.19074 8.52024 8.25 8.66331 8.25 8.8125C8.25 8.96168 8.19074 9.10476 8.08525 9.21025C7.97976 9.31574 7.83668 9.375 7.6875 9.375H6.5625C6.41331 9.375 6.27024 9.31574 6.16475 9.21025C6.05926 9.10476 6 8.96168 6 8.8125C6 8.66331 6.05926 8.52024 6.16475 8.41475C6.27024 8.30926 6.41331 8.25 6.5625 8.25ZM10.5 1.5015L14.25 5.25H10.6875C10.6378 5.25 10.5901 5.23025 10.5549 5.19508C10.5198 5.15992 10.5 5.11223 10.5 5.0625V1.5015ZM2.0625 11.25C2.21168 11.25 2.35476 11.3093 2.46025 11.4148C2.56574 11.5202 2.625 11.6633 2.625 11.8125V13.125C2.625 13.7217 2.86205 14.294 3.28401 14.716C3.70597 15.1379 4.27826 15.375 4.875 15.375H13.125C13.7217 15.375 14.294 15.1379 14.716 14.716C15.1379 14.294 15.375 13.7217 15.375 13.125V11.8125C15.375 11.6633 15.4343 11.5202 15.5398 11.4148C15.6452 11.3093 15.7883 11.25 15.9375 11.25C16.0867 11.25 16.2298 11.3093 16.3352 11.4148C16.4407 11.5202 16.5 11.6633 16.5 11.8125V13.125C16.5 14.0201 16.1444 14.8785 15.5115 15.5115C14.8785 16.1444 14.0201 16.5 13.125 16.5H4.875C3.97989 16.5 3.12145 16.1444 2.48851 15.5115C1.85558 14.8785 1.5 14.0201 1.5 13.125V11.8125C1.5 11.6633 1.55926 11.5202 1.66475 11.4148C1.77024 11.3093 1.91332 11.25 2.0625 11.25Z" fill="#b2b1b1" />
                </svg>
                <span
                  className={classnames('item-name', { 'hide-name': minimize })}
                >
                  Analytics
                </span>
              </NavLink>
            </li>}
          {features && features.includes('CONVERSATIONS_ENABLED') && (
            <li>
              <NavLink
                className="item"
                activeClassName="item--active"
                to="/app/conversation"
              >
                <i className="material-icons">textsms</i>
                <span
                  className={classnames('item-name', { 'hide-name': minimize })}
                >
                  Conversations
                  {this.props.conversations.sidenav_count > 0 && (
                    <span
                      className={classnames('need-attention-count', {
                        'hide-name': minimize,
                      })}
                    >
                      ({this.props.conversations.sidenav_count})
                    </span>
                  )}
                </span>
              </NavLink>
            </li>
          )}
          {features && 
            features.includes('CAMPAIGNS_ENABLED') && 
            (!features.includes('OUTREACH_HIDDEN') || !features.includes('LEAD_ENGAGE_HIDDEN')) && (
            <li
              className={classnames({
                active: !isCampaignsCollapsed,
              })}
            >
              <div
                className={classnames('item', {
                  'item--active': campaignsactive,
                })}
                onClick={() => this.onCampaignsClick(isCampaignsCollapsed)}
              >
                {features && features.includes('MARKETING_STAFF_ENABLED') ? (
                  <NavLink className="not-highlight" to="/app/campaigns">
                    <i className="material-icons">content_paste</i>
                    <span
                      className={classnames('item-name', {
                        'hide-name': minimize,
                      })}
                    >
                      Campaigns
                    </span>
                  </NavLink>
                ) : (
                  <>
                    <i className="material-icons">content_paste</i>
                    <span
                      className={classnames('item-name', {
                        'hide-name': minimize,
                      })}
                    >
                      Campaigns
                    </span>
                  </>
                )}
                {!isCampaignsCollapsed ? (
                  <i
                    className="material-icons"
                    style={{ fontSize: '24px' }}
                  >arrow_drop_up</i>
                ) : (
                  <i
                    className="material-icons"
                    style={{ fontSize: '24px' }}
                  >arrow_drop_down</i>
                )}
              </div>
              <ul className="side-nav__items">
                {features && !features.includes('OUTREACH_HIDDEN') && (
                  <li>
                    <NavLink
                      className="item"
                      activeClassName="item--active"
                      to="/app/outreach"
                    >
                      <span
                        className={classnames('item-name', {
                          'hide-name': minimize,
                        })}
                      >
                        Outreach
                      </span>
                    </NavLink>
                  </li>
                )}
                {features && !features.includes('LEAD_ENGAGE_HIDDEN') && (
                  <li>
                    <NavLink
                      className="item"
                      activeClassName="item--active"
                      to="/app/leadengage"
                    >
                      <span
                        className={classnames('item-name', {
                          'hide-name': minimize,
                        })}
                      >
                        Lead Engage
                      </span>
                    </NavLink>
                  </li>
                )}
              </ul>
            </li>
          )}
          {features && !features.includes('APPOINTMENT_REMINDER_HIDDEN') && 
            this.props &&
            this.props.currentDomain &&
            this.props.currentDomain !== 'FITNESS' && (
              <li>
                <NavLink
                  className="item"
                  activeClassName="item--active"
                  to="/app/apptreminder"
                >
                  <div>
                    <svg
                      width="15"
                      height="14"
                      viewBox="0 0 15 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        className="svg-path"
                        d="M10.4097 6.64361H9.37242V9.40957L11.4469 10.7925L11.9655 9.94202L10.4097 8.89095V6.64361ZM10.0639 4.2234L0.383057 0.0744629V4.91489L6.60646 6.29787L0.383057 7.68084V12.5213L5.41018 10.3707C5.97721 12.4037 7.84423 13.9042 10.0639 13.9042C12.7331 13.9042 14.9043 11.733 14.9043 9.06382C14.9043 6.39467 12.7331 4.2234 10.0639 4.2234ZM10.0639 12.5213C8.16231 12.5213 6.62029 10.9862 6.60646 9.08457V9.03616C6.61339 8.12324 6.98053 7.24999 7.62802 6.60638C8.27551 5.96278 9.15096 5.60089 10.0639 5.59946C11.9724 5.59946 13.5214 7.1484 13.5214 9.05691C13.5214 10.9654 11.9724 12.5213 10.0639 12.5213Z"
                        fill="#B2B1B1"
                      />
                    </svg>
                  </div>
                  <span
                    className={classnames('item-name', {
                      'hide-name': minimize,
                    })}
                  >
                    Appt Reminders
                  </span>
                </NavLink>
              </li>
            )}
          {features && features.includes('SCHEDULE_ENABLED') && (
            <li
              className={classnames({
                active: !isScheduleCollapsed,
              })}
            >
              <div
                className={classnames('item', {
                  'item--active': isscheduleactive,
                })}
                onClick={() => this.onScheduleClick(isScheduleCollapsed)}
              >
                <i className="material-icons">event</i>

                <span
                  className={classnames('item-name', { 'hide-name': minimize })}
                >
                  Schedule
                </span>

                {!isScheduleCollapsed ? (
                  <i
                    className="material-icons"
                    style={{ fontSize: '24px' }}
                  >arrow_drop_up</i>
                ) : (
                  <i
                    className="material-icons"
                    style={{ fontSize: '24px' }}
                  >arrow_drop_down</i>
                )}
              </div>
              <ul className="side-nav__items">
                <li>
                  <NavLink
                    className="item"
                    activeClassName="item--active"
                    to="/app/servicetypes"
                  >
                    <span
                      className={classnames('item-name', {
                        'hide-name': minimize,
                      })}
                    >
                      Service Types
                    </span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    className="item"
                    activeClassName="item--active"
                    to="/app/schedulepreview"
                  >
                    <span
                      className={classnames('item-name', {
                        'hide-name': minimize,
                      })}
                    >
                      Schedule Preview
                    </span>
                  </NavLink>
                </li>
                {!(auth.booking_software == 'DENTICON' || auth.booking_software == 'CLOUD9' || auth.booking_software == 'DENTRIX_ASCEND' || auth.booking_software == 'OPEN_DENTAL') && (
                 <>
                    <li>
                      <NavLink
                        className="item"
                        activeClassName="item--active"
                        to="/app/scheduledefinition"
                      >
                        <span
                          className={classnames('item-name', {
                            'hide-name': minimize,
                          })}
                        >
                          Schedule Definition
                        </span>
                      </NavLink>
                    </li>
                    </>
                 )}
                <li>
                  <NavLink
                    className="item"
                    activeClassName="item--active"
                    to="/app/scheduleblocks"
                  >
                    <span
                      className={classnames('item-name', {
                        'hide-name': minimize,
                      })}
                    >
                      Schedule Blocks
                    </span>
                  </NavLink>
                </li>
                {(auth.booking_software == 'CLOUD9') && 
                  (<li>
                    <NavLink
                      className="item"
                      activeClassName="item--active"
                      to="/app/staffmapping"
                    >
                      <span
                        className={classnames('item-name', {
                          'hide-name': minimize,
                        })}
                      >
                        Staff Mapping
                      </span>
                    </NavLink>
                  </li>)
                }
              </ul>
            </li>
          )}
          {features && features.includes('PREFERENCES_ENABLED') && (
            <li
              className={classnames({
                active: !isAIsetupCollapsed,
              })}
            >
              <div
                className={classnames('item', {
                  'item--active': setupactive,
                })}
                onClick={() => this.onAIsetupClick(isAIsetupCollapsed)}
              >
                <i className="material-icons">settings</i>
                <span
                  className={classnames('item-name', { 'hide-name': minimize })}
                >
                  AI Setup
                </span>
                {!isAIsetupCollapsed ? (
                  <i
                    className="material-icons"
                    style={{ fontSize: '24px' }}
                  >arrow_drop_up</i>
                ) : (
                  <i
                    className="material-icons"
                    style={{ fontSize: '24px' }}
                  >arrow_drop_down</i>
                )}
              </div>
              <ul className="side-nav__items">
                {isAdmin && 
                  !(features && features.includes('WEB_CHAT_HIDDEN') && features.includes('WEB_TO_TEXT_HIDDEN')) && 
                  (features && features.includes('WEB_TO_TEXT_ENABLED') || features.includes('WEB_CHAT_ENABLED')) && (
                    <li>
                      <NavLink
                        className="item"
                        activeClassName="item--active"
                        to="/app/webchat"
                      >
                        {this.props &&
                          this.props.currentDomain &&
                          this.props.currentDomain === 'DENTAL' ? (
                              <span
                                className={classnames('item-name', {
                                  'hide-name': minimize,
                                })}
                              >
                                Web To Text
                              </span>
                          ) : (
                                  <span
                                    className={classnames('item-name', {
                                      'hide-name': minimize,
                                    })}
                                  >
                                    Web Chat
                                  </span>
                                )}
                      </NavLink>
                    </li>
                  )}
                {features && !features.includes('INCOMING_VOICE_HIDDEN') &&
                  <li key="preference">
                    <NavLink
                      className="item"
                      activeClassName="item--active"
                      to="/app/voiceaiconfig"
                    >
                      <span
                        className={classnames('item-name', {
                          'hide-name': minimize,
                        })}
                      >
                        Voice AI
                      </span>
                    </NavLink>
                  </li>}
                {features && this.props.currentDomain === 'DENTAL' && isAdmin ? (
                  <>
                    {(!features.includes('WEB_STORE_HIDDEN') && features.includes('WEB_STORE_ENABLED')) && 
                      <li>
                        <NavLink
                          className="item"
                          activeClassName="item--active"
                          to="/app/webbooking"
                        >
                          <span
                            className={classnames('item-name', {
                              'hide-name': minimize,
                            })}
                          >
                            Online Booking
                          </span>
                        </NavLink>
                      </li>
                    }
                    <li>
                      <NavLink
                        className="item"
                        activeClassName="item--active"
                        to="/app/preferences"
                      >
                        <span
                          className={classnames('item-name', {
                            'hide-name': minimize,
                          })}
                        >
                          Preferences
                        </span>
                      </NavLink>
                    </li>
                    <li
                      className={classnames({
                        active: setup && !isDentalSetupCollapsed,
                      })}
                    >
                      <NavLink
                        className={classnames('item', {
                          'item--active': setup,
                        })}
                        to="/app/setup"
                        onClick={this.onDentalSetupClick}
                      >
                        <span
                          className={classnames('item-name', {
                            'hide-name': minimize,
                          })}
                        >
                          Setup
                        </span>
                        {errorCount ? (
                          <span className="error-icon">
                            <i className="material-icons" aria-hidden="true">error</i>
                          </span>
                        ) : (
                          undefined
                        )}
                        {enableSetUP(features) && (
                          <i
                            className="material-icons"
                            style={{ fontSize: '24px' }}
                          >
                            {setup && !isDentalSetupCollapsed ? 'arrow_drop_up' : 'arrow_drop_down'}
                          </i>
                        )}
                      </NavLink>
                      <ul className="side-nav__items">
                        {features && features.includes('LOCAL_STAFF_ENABLED') && (
                          <li>
                            <NavLink
                              className="item"
                              activeClassName="item--active"
                              to="/app/staff"
                              onClick={this.onPreferencesClick}
                            >
                              <i className="material-icons">person</i>
                              <span
                                className={classnames('item-name', {
                                  'hide-name': minimize,
                                })}
                              >
                                Staff
                              </span>
                              {isPreferencesDisabled ? (
                                <i className="material-icons" data-tip="Please complete the setup first">lock</i>
                              ) : null}
                            </NavLink>
                          </li>
                        )}
                        {features &&
                          features.includes('LOCAL_SERVICE_ENABLED') && (
                            <li>
                              <NavLink
                                className="item"
                                activeClassName="item--active"
                                to="/app/services"
                                onClick={this.onPreferencesClick}
                              >
                                <i className="material-icons">business</i>
                                <span
                                  className={classnames('item-name', {
                                    'hide-name': minimize,
                                  })}
                                >
                                  Services
                                </span>
                                {isPreferencesDisabled ? (
                                  <i className="material-icons" data-tip="Please complete the setup first">lock</i>
                                ) : null}
                              </NavLink>
                            </li>
                        )}
                        {features &&
                          features.includes('LOCAL_SCHEDULE_ENABLED') && (
                            <li>
                              <NavLink
                                className="item"
                                activeClassName="item--active"
                                to="/app/schedules"
                                onClick={this.onPreferencesClick}
                              >
                                <i className="material-icons">calendar_today</i>
                                <span
                                  className={classnames('item-name', {
                                    'hide-name': minimize,
                                  })}
                                >
                                  Schedules
                                </span>
                                {isPreferencesDisabled ? (
                                  <i className="material-icons" data-tip="Please complete the setup first">lock</i>
                                ) : null}
                              </NavLink>
                            </li>
                        )}
                      </ul>
                    </li>
                  </>
                ) : (
                  isAdmin && [
                    <li key="preference">
                      <NavLink
                        className="item"
                        activeClassName="item--active"
                        to="/app/preferences"
                      >
                        <span
                          className={classnames('item-name', {
                            'hide-name': minimize,
                          })}
                        >
                          Business Preferences
                        </span>
                      </NavLink>
                    </li>,
                    <li
                      key="setup"
                      className={classnames({
                        active: setup,
                      })}
                    >
                      <NavLink
                        className={classnames('item', {
                          'item--active': setup,
                        })}
                        to="/app/setup"
                      >
                        <span
                          className={classnames('item-name', {
                            'hide-name': minimize,
                          })}
                        >
                          Setup
                        </span>
                        {errorCount ? (
                          <span className="error-icon">
                            <i className="material-icons" aria-hidden="true">error</i>
                          </span>
                        ) : (
                          undefined
                        )}
                      </NavLink>
                    </li>,
                  ]
                )}
              </ul>
            </li>
          )}
          {features && !features.includes('BILLING_INFO_HIDDEN') && features.includes('BILLING_INFO_ENABLED') && (
            <li>
              <NavLink
                className="item"
                activeClassName="item--active"
                to="/app/billing"
              >
                <i className="material-icons">credit_card</i>
                <span
                  className={classnames('item-name', { 'hide-name': minimize })}
                >
                  Billing Info
                </span>
              </NavLink>
            </li>
          )}
          {features && features.includes('HELP_ENABLED') && (
            <li>
              <NavLink
                className="item"
                activeClassName="item--active"
                to="/app/help"
              >
                <i className="material-icons">help</i>
                <span
                  className={classnames('item-name', { 'hide-name': minimize })}
                >
                  Help
                </span>
              </NavLink>
            </li>
          )}
          {isCSLogin && <li>
            <NavLink
              className="item"
              activeClassName="item--active"
              to="/app/aiAssists"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="20 50 620 560" style={{width: "19px", height: "19px"}}>
                <path style={{fill: "#b2b1b1"}} d="M480 272C503.7 272 525.6 279.3 543.7 291.9C536.9 164.9 425 64 288 64C146.6 64 32 171.5 32 304C32 358.3 51.2 408.3 83.6 448.5L34.8 540.8C30 549.8 31.5 560.8 38.4 568.3C45.3 575.8 56.2 578.1 65.5 574.1L183.9 523.4C211.1 534.8 240.8 541.8 272 543.6C272.1 524.7 276.9 505.6 287 488.1C304.1 458.4 332.8 439.6 364 433.9L373.2 417.9C369.8 407.2 368 395.9 368 384.1C368 322.2 418.1 272.1 480 272.1zM328.6 512C310.9 542.6 321.4 581.7 352 599.4C382.6 617.1 421.7 606.6 439.4 576C440.9 573.4 442.2 570.7 443.3 568L516.6 568C517.7 570.7 519 573.4 520.5 576C538.2 606.6 577.3 617.1 607.9 599.4C638.5 581.7 649 542.6 631.3 512C617.9 488.8 592.2 477.2 567.3 480.6L549.7 449.9C538.7 461.6 524.7 470.5 509.1 475.5L525.6 504.4C521.8 509.2 518.8 514.4 516.6 520L443.2 520C441 514.4 437.9 509.2 434.2 504.4L467.2 446.7C471.3 447.5 475.6 448 480 448C515.3 448 544 419.3 544 384C544 348.7 515.3 320 480 320C444.7 320 416 348.7 416 384C416 397.4 420.1 409.8 427.2 420.1L392.6 480.6C367.6 477.2 342 488.9 328.6 512z"/>
              </svg>
              <span
                className={classnames('item-name', { 'hide-name': minimize })}
              >
                AI Assists
              </span>
            </NavLink>
          </li>
          }
          {isCSLogin && !isBusinessUnsubscribed && !isBusinessPaused && <li>
            <NavLink
              className="item"
              activeClassName="item--active"
              to="/app/serviceAgent"
            >
              {/* <i className="material-icons">headphones</i> */}
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" role="img" aria-labelledby="title">
                <title id="title">Business services</title>
                <path fill="#B2B1B1" d="M14 3h-4a2 2 0 0 0-2 2v1h2V5h4v1h2V5a2 2 0 0 0-2-2Z"/>
                <path fill="#B2B1B1" d="M5 6h14a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3Zm-1 5h16V9a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v2Z"/>
              
                <path fill="#B2B1B1" d="M16.5 13a.8.8 0 0 1 .78.6l.09.33.33.09a.8.8 0 0 1 .54.54l.09.33.33.09a.8.8 0 0 1 0 1.56l-.33.09-.09.33a.8.8 0 0 1-.54.54l-.33.09-.09.33a.8.8 0 0 1-1.56 0l-.09-.33-.33-.09a.8.8 0 0 1-.54-.54l-.09-.33-.33-.09a.8.8 0 0 1 0-1.56l.33-.09.09-.33a.8.8 0 0 1 .54-.54l.33-.09.09-.33A.8.8 0 0 1 16.5 13Zm0 1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"/>
              </svg>
              <span
                className={classnames('item-name', { 'hide-name': minimize })}
              >
                Service agent
              </span>
            </NavLink>
          </li>
          }
        </ul>
        <ReactTooltip place="right" type="warning" />
      </div>
    );
  }
}

SideNav.defaultProps = {
  dashboard: {
    tasksStatus: {},
  },
};

SideNav.propTypes = {
  app: PropTypes.shape({
    leftSidenav: PropTypes.bool,
  }).isRequired,
  voicemails: PropTypes.shape({
    unreadCount: PropTypes.number,
  }).isRequired,
  dashboard: PropTypes.shape({
    tasksStatus: PropTypes.shape({
      call_forwarding: PropTypes.string,
      bookingSW_connect: PropTypes.string,
    }),
  }).isRequired,
  softwares: PropTypes.shape({
    info: PropTypes.shape({
      STUIDIO_NAME: PropTypes.string,
    }),
  }).isRequired,
  conversations: PropTypes.shape({
    conversationSummary: PropTypes.shape({
      followup_count: PropTypes.number,
    }),
  }).isRequired,
  currentDomain: PropTypes.string.isRequired,
};

export default SideNav;
